import { httpClient as _httpClient } from "@marketplace/http";

import { BASE_API_URL } from "@/configs";

import { afterResponse, beforeRequest } from "./http-client-interceptors";

export const httpClient = _httpClient.extend({
  prefixUrl: BASE_API_URL,
  hooks: {
    beforeRequest,
    afterResponse
  }
});

const BASE_API_URL_WITHOUT_VERSION = BASE_API_URL.replace(/\/api\/v1\/?$/, "");

export const httpClientNoApiVersion = _httpClient.extend({
  prefixUrl: BASE_API_URL_WITHOUT_VERSION,
  hooks: {
    beforeRequest,
    afterResponse
  }
});
